import type { PlaybackFile } from "../types";

// ISO local del DVR (sin sufijo Z). Dahua espera hora local del equipo.
export function toLocalIso(d: Date): string {
  const p = (n: number) => String(n).padStart(2, "0");
  return (
    `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}` +
    `T${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
  );
}

// El NVR escanea su indice por todo [start,end] al responder el DESCRIBE RTSP:
// un dia completo cuesta ~15s, un archivo ~0.7s. Por eso acotamos `end` al fin
// del archivo que cubre el seek; en hueco/sin archivos, tope de 3h.
export function playbackEndFor(
  iso: string,
  files: PlaybackFile[],
  dayEndIso: string,
): string {
  const t = new Date(iso).getTime();
  const covering = files.find(
    (f) => new Date(f.start).getTime() <= t && new Date(f.end).getTime() > t,
  );
  if (covering) return covering.end;
  const cap = toLocalIso(new Date(t + 3 * 60 * 60 * 1000));
  const nextFile = files.find((f) => new Date(f.start).getTime() > t);
  const candidate = nextFile ? nextFile.end : dayEndIso;
  return candidate < cap ? candidate : cap;
}
